import React from 'react';
import {DayOfWeekName, DaysOfWeek} from "../../../gd/types/types";

type Props = {
    className?          : string
    onChange?           : callback
    disabled?           : boolean


    value               : DaysOfWeek

    days                : DayOfWeekName[]
}

type State ={
    value       : DaysOfWeek
}


export default class WeekdaysPicker extends React.Component<Props,State> {

    public days         : DayOfWeekName[]   = []

    // static propTypes = {
    //     days: PropTypes.array,    // available for picking days...
    //     value: PropTypes.object,
    //
    //     disabled: PropTypes.bool,
    //
    //     onChange: PropTypes.func,
    //     onSelect: PropTypes.func,
    // };

    static defaultProps = {
        days: ['mon','tue','wed','thu','fri','sat','sun'],
        value: {
            'mon': false,
            'tue': false,
            'wed': false,
            'thu': false,
            'fri': false,
            'sat': false,
            'sun': false
        }
    }

    constructor(props:Props) {
        super(props);

        this.state = {
            value       : props.value
        };

        this._processDays(props);
    }

    UNSAFE_componentWillReceiveProps(newProps:any) {
        if (newProps.days) this._processDays(newProps)
    }

    _processDays = (props:any) => {
        const days : DayOfWeekName[] = [];
        _.forEach(props.days,(dayName:DayOfWeekName)=>{
            days.push(dayName)
        });
        this.days = days;
    }

    setValue = (value:any) => {
        this.setState({
            value: value
        });
    }

    onDayClick = (day:DayOfWeekName) => {
        if (this.props.disabled) return;

        const { value } = this.state;

        value[day] = !value[day];

        this.setState({
            value: value
        }, ()=>{
            this.props.onChange?.(value)
        })
    }

    render() {
        return (
            <div className={Classes('gd-weekdays-picker flex-no-shrink',this.props.className)}>
                {this.days.map((dayName:DayOfWeekName,key:number)=>{

                    const isSelected = this.state.value[dayName];
                    const isWeekend = (dayName === DayOfWeekName.SAT || dayName === DayOfWeekName.SUN);

                    const classes = Classes('week-day',{
                        'selected'      : isSelected,
                        'not-selected'  : !isSelected,
                        'weekend'       : isWeekend
                    })

                    return (
                        <div className={classes} key={key} onClick={this.onDayClick.bind(this, dayName)} >
                            <div className="week-day-container">{gd.utils.strToTitleCase(dayName)}</div>
                        </div>
                    );
                })}
            </div>
        )
    }
}